import { type PastDuePolicy, type ReminderSettings, ReminderType } from '../../../../../models/Scheduling'
import { type TrackingEvent } from '../../../../../store/metrics/metrics'
import { TrackEvent } from '../../../../../apps/professional-app/fa/common/tracking'
import { entriesChanged, type ReminderSettingsDraft } from '../reminderDrafts'

export const SAVE_ERROR_MESSAGE = "Couldn't save changes. Please try again."

export type PendingConfirm = { kind: 'turn-off' } | { kind: 'past-due'; pastDueCount: number }

interface ConfirmModalCopy {
  title: string
  body: string
}

export const TURN_OFF_MODAL_COPY: Record<ReminderType, ConfirmModalCopy> = {
  [ReminderType.FOLLOW_UP]: {
    title: 'Turn off booking follow-ups?',
    body: "Clients who haven't booked won't receive any more follow-ups.",
  },
  [ReminderType.MEETING]: {
    title: 'Turn off meeting reminders?',
    body: "Clients won't receive reminders before their upcoming meetings.",
  },
}

interface ReminderSaveEventsOptions {
  reminderType: ReminderType
  draft: ReminderSettingsDraft
  settings: ReminderSettings
  pastDuePolicy: PastDuePolicy
  pastDueCount?: number
}

export const reminderSaveEvents = ({ reminderType, draft, settings, pastDuePolicy, pastDueCount }: ReminderSaveEventsOptions): TrackingEvent[] => {
  const events: TrackingEvent[] = []
  if (draft.enabled !== settings.enabled) {
    events.push(
      draft.enabled
        ? { eventName: TrackEvent.SCHEDULING_REMINDERS_ENABLED, eventDetails: { reminderType, entryCount: draft.rows.length } }
        : { eventName: TrackEvent.SCHEDULING_REMINDERS_DISABLED, eventDetails: { reminderType } },
    )
  }
  if (entriesChanged(draft, settings)) {
    const pastDueDetails = pastDueCount != null ? { pastDuePolicy, pastDueCount } : {}
    events.push({
      eventName: TrackEvent.SCHEDULING_REMINDER_SETTINGS_UPDATED,
      eventDetails: { reminderType, entryCount: draft.rows.length, ...pastDueDetails },
    })
  }
  return events
}
